import axios from "axios";

import { getAuthToken } from "@/api/client";

import type { RecordAiCreditSpendBodySourceType } from "@/api/api.generated.schemas";
import type { NodeJson } from "@corca/data";

// TODO: should be auto-generated

export type OcrSource = { type: RecordAiCreditSpendBodySourceType; uid: string };

export async function ocr(
  url: string,
  source: OcrSource | undefined,
): Promise<NodeJson | { error: string }> {
  const apiUrl = process.env.NEXT_PUBLIC_OCR_API_URL || "/ai/ocr";
  const token = await getAuthToken();
  const { data } = await axios.post<NodeJson | { error: string }>(
    apiUrl,
    { url, source },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
}

type SuggestQuestionsResponse = {
  questions: string[];
};

type SuggestQuestionsOptions = {
  documentUid?: string;
  userUid?: string;
  signal?: AbortSignal;
};

export async function suggestQuestions(
  text: string,
  { documentUid, userUid, signal }: SuggestQuestionsOptions = {},
): Promise<string[]> {
  const apiUrl = process.env.NEXT_PUBLIC_SUGGEST_QUESTIONS_API_URL || "/ai/suggest-questions";

  try {
    const { data } = await axios.post<SuggestQuestionsResponse>(
      apiUrl,
      { text, documentUid },
      {
        headers: { "X-User-Uid": userUid },
        signal,
      },
    );
    return data.questions;
  } catch {
    return [];
  }
}
